import { GetServerSideProps } from 'next'
import Link from 'next/link'
import quizService from '@/services/quiz.service'
import { QuizType } from '@/types/quiz'
import Banner from '@/components/UI/Banner/Banner'
import CHGamesHead from '@/components/Layout/CHGamesHead/CHGamesHead'
import styles from './QuizzesPage.module.scss'
import {useState} from "react";
import Button from "@/components/UI/Button/Button";
import { parseMarkdown } from '@/utils/parseMarkdown';

type QuizWithSlug = QuizType & { slug: string }

type Props = {
  quizzes: QuizWithSlug[]
  total: number
  page: number
}

const PAGE_SIZE = 10

const QuizzesPage = ({ quizzes, total, page }: Props) => {
  const totalPages = Math.ceil(total / PAGE_SIZE)
  const [localQuizzes, setLocalQuizzes] = useState(quizzes)
  const [currentPage, setCurrentPage] = useState(page)

  const loadMore = async () => {
    if (currentPage >= totalPages) return
    const nextPage = currentPage + 1
    const { quizzes: newQuizzes } = await quizService.getQuizzesByPage(nextPage)
    setLocalQuizzes((prev) => [...prev, ...newQuizzes])
    setCurrentPage(nextPage)
  }


  return (
    <div className={styles.container}>
      <CHGamesHead
        title="Quizzes"
        description="Fun Magic: The Gathering personality quizzes by EDHREC. Answer a few questions to find out which card, commander, or color you are."
      />
      <Banner imageVerticalOffset={20} image="https://cards.scryfall.io/art_crop/front/c/5/c54a2256-673d-4d93-9e1d-7790bf254881.jpg">
        <div className={styles.subtitle}>QUIZZES</div>
        <h1>All Quizzes</h1>
      </Banner>
      <div className={styles.page}>
        <div className={styles.grid}>
          {localQuizzes.map(quiz => (
            <Link key={quiz.slug} href={`/quiz/${quiz.slug}`} className={styles.card}>
              {quiz.imageUrl && (
                <div
                  className={styles.cardImage}
                  style={{ backgroundImage: `url(${quiz.imageUrl})` }}
                />
              )}
              <div className={styles.cardOverlay} />
              <div className={styles.cardContent}>
                <h2 className={styles.cardName}>{quiz.name}</h2>
                <div className={styles.cardMeta}>
                  {quiz.date} &middot; by {quiz.author}
                </div>
                {(quiz.shortDescription || quiz.description) && (
                  <p className={styles.cardDescription}>{parseMarkdown(quiz.shortDescription || quiz.description)}</p>
                )}
              </div>
            </Link>
          ))}
        </div>
        {currentPage < totalPages && (
          <div className={styles.buttonContainer}>
            <Button onClick={loadMore}>Load More</Button>
          </div>
        )}
      </div>
    </div>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { quizzes, total } = await quizService.getQuizzesByPage()
  return {
    props: { quizzes, total, page: 1 },
  }
}

export default QuizzesPage
